import styled from 'styled-components';
import PersonIcon from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';
import { Fade } from 'react-reveal';
function ForgotPassword() {
  return (
      <Container>
          <div className="container">
              <Fade up>

              <div className="col-xl-7 col-sm-10 col-md-9 forgot-pw-container text-center">
                <PersonIcon id='user-icon'/>
          <h1 className='h3'>Trouble Logging In?</h1>
          <p>Enter Your Email or Phone To Reset Your Password</p>
                  <form action="">
                      <input type="email" placeholder='Enter Your Email or Phone Number' />
                      <div className="btn-group">
                          <Link to='/login'>
                      <button>Cancel</button>
                          </Link>

                          <Link to='/Reset-password'>

                              
                      <button type='submit'>Send</button>
                          </Link>
                      </div>

                  </form>
                  
          
              </div>
              </Fade>
          
          </div>
              
      </Container>

                
  )
}

export default ForgotPassword
const Container = styled.div` 
/* text-align:center ; */
margin-top:80px ;
margin-bottom:50px ;
h1{
    color:black ;
}
.forgot-pw-container{
    margin:auto ;
    margin-top:150px;
    box-shadow:10px 10px solid black ;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    border-radius: 10px;
    box-sizing: border-box;
    padding:10px ;
}
input{
    width:80% ;
    margin-left:auto ;
    margin-right:auto ;
    height:40px ;
    border:1px solid white;
    padding:10px ;
    border-radius:5px ;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    &:focus{
        /* color:#fa7525; */
        border:1px solid #fa7525 ;
    }
    &:hover{
        border:1px solid #fa7525 ;
    }
}

#user-icon{
    font-size:50px ;
    color:#fa7525 ;
}

    button{
        background-color:#fa7525;
        border:none ;
        padding:9px 20px 9px 20px ;
        margin:10px;
        margin-top:2em ;
        border-radius:10px ;
        width:100px ;
        &:hover{
            background-color:black ;
            color:#fa7525 ;
        }
    }


`
